<script>
    import BlockGlobal from "./BlockGlobal.svelte";

    export let data, isCollapsable = false, isCollapsed = false;

</script>
<div class="col20 f-left t-center mb-25 mt-15">
    <h4 class="t-left">Booking Answers</h4>
</div>
<BlockGlobal bind:data={data} isCollapsable={true} isCollapsed={true}/>